import { atom } from 'jotai';

import { GuidedTourState } from './constants';

export const guidedTourState = atom(GuidedTourState.DISABLED);

export const guidedTourCompletedModules = atom<number[]>([]);
